webpackJsonp([2,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(113);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueResource = __webpack_require__(179);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _vueRouter = __webpack_require__(180);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _routes = __webpack_require__(127);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _store = __webpack_require__(128);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _filters = __webpack_require__(126);
	
	var _App = __webpack_require__(149);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.filter('count', _filters.count);
	
	_vue2.default.use(__webpack_require__(178));
	
	_vue2.default.use(_vueResource2.default);
	
	_vue2.default.use(_vueRouter2.default);
	
	if (window.localStorage) {
	  if (_store2.default.state.user !== window.localStorage.getItem('user')) {
	    _store2.default.dispatch('doSetUser', JSON.parse(window.localStorage.getItem('user')));
	    _store2.default.dispatch('doSetToken', window.localStorage.getItem('token'));
	  }
	}
	
	_vue2.default.http.interceptors.push(function (request, next) {
	  var headers = request.headers;
	  var token = window.localStorage.getItem('token');
	  var user = JSON.parse(window.localStorage.getItem('user'));
	
	  if (!headers.hasOwnProperty('Authorization')) {
	    _vue2.default.http.headers.common['Authorization'] = 'fb ' + user.id + ' ' + token;
	  }
	
	  next(function (response) {
	    if (response.status == 401) {
	      window.localStorage.removeItem('token');
	      window.localStorage.removeItem('user');
	    }
	  });
	});
	
	var router = new _vueRouter2.default({
	  routes: _routes2.default,
	  mode: 'history',
	  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
	    return savedPosition || { x: 0, y: 0 };
	  }
	});
	
	router.beforeEach(function (to, from, next) {
	  if (to.matched.some(function (record) {
	    return record.meta.auth;
	  })) {
	    if (!window.localStorage.getItem('token') && window.localStorage.getItem('token') == null) {
	      next({
	        path: '/login'
	      });
	    } else {
	      next();
	    }
	  } else if (to.fullPath == "/login" && window.localStorage.getItem('token') && window.localStorage.getItem('token') == null) {
	    next({
	      path: '/'
	    });
	  } else {
	    next();
	  }
	});
	
	new _vue2.default({
	  el: '#root',
	  router: router,
	  store: _store2.default,
	  render: function render(h) {
	    return h(_App2.default);
	  }
	});

/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'NotFound'
	};

/***/ },
/* 115 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'App',
	  data: function data() {
	    return {
	      section: 'Head',
	      version: '0.10.0',
	      callingAPI: false,
	      serverURI: 'http://10.110.1.10:8080',
	      caller: this.$http
	    };
	  },
	  methods: {
	    callAPI: function callAPI(method, url, data) {
	      this.callingAPI = true;
	      url = url || this.serverURI;
	      return this.caller({
	        url: url,
	        method: method,
	        data: data
	      });
	    },
	    logout: function logout() {
	      this.$store.dispatch('SET_USER', null);
	      this.$store.dispatch('SET_TOKEN', null);
	
	      if (window.localStorage) {
	        window.localStorage.setItem('user', null);
	        window.localStorage.setItem('token', null);
	      }
	
	      this.$router.push('/login');
	    }
	  }
	};

/***/ },
/* 116 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'Settings',
	  data: function data() {
	    return {
	      driver: {
	        id: null,
	        name: null,
	        email: null,
	        license: null,
	        phone: null,
	        taxi: null
	      }
	    };
	  },
	  computed: {
	    store: function store() {
	      return this.$parent.$store;
	    }
	  },
	  mounted: function mounted() {
	    this.getdriver();
	  },
	  methods: {
	    getdriver: function getdriver() {
	      var state = this.store.state;
	      var fbid = this.$route.params.fbid;
	      var self = this;
	
	      var url = state.serverURI + 'api/getDriver/' + fbid;
	
	      this.$http.get(url).then(function (response) {
	        self.driver = response.data;
	      }, function (response) {});
	    },
	    deleteDriver: function deleteDriver() {
	      var state = this.store.state;
	      var self = this;
	      var url = state.serverURI + 'api/updateDriver/';
	      this.$http.post(url, self.driver).then(function (response) {
	        if (response.status == 200) {
	          self.$router.push({ 'name': 'Driver List' });
	        }
	      }, function (response) {});
	    }
	  }
	};

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(4);
	__webpack_require__(3);
	module.exports = {
	  name: 'Tables',
	  data: function data() {
	    return {
	      showModal: false
	    };
	  },
	  mounted: function mounted() {
	    var state = this.$store.state;
	    var store = this.$store;
	    var self = this;
	
	    this.$nextTick(function () {
	      (0, _jquery2.default)('#device-list tbody').on('click', 'a', function () {
	        if ((0, _jquery2.default)(this).attr('class') == "view") {
	          self.deviceView((0, _jquery2.default)(this).attr('id'));
	        }
	      });
	      (0, _jquery2.default)('#device-list').DataTable({
	        'processing': true,
	        'serverSide': true,
	        'aaSorting': [[9, 'desc']],
	        "ajax": {
	          "url": state.serverURI + 'api/a/device-list',
	          "dataType": 'json',
	          "type": "GET",
	          "beforeSend": function beforeSend(xhr) {
	            xhr.setRequestHeader("Authorization", 'fb ' + state.user.id + ' ' + state.token);
	          },
	          'error': function error($xhr) {
	            if ($xhr.status === 401) {
	              store.dispatch('doSetToken', null);
	              store.dispatch('doSetUser', null);
	
	              if (window.localStorage) {
	                window.localStorage.removeItem('user');
	                window.localStorage.removeItem('token');
	              }
	              self.$router.push('/login');
	            }
	          }
	        },
	        "columnDefs": [{
	          "render": function render(data, type, row) {
	            return '<a href="javascript:;" class="view" id="' + data + '" >' + data.substring(0, 8) + '</a>';
	          },
	          "targets": 0,
	          "bSortable": false
	        }]
	      });
	    });
	  },
	  methods: {
	    deviceView: function deviceView(iid) {
	      var self = this;
	      console.log(self);
	      self.$router.push({ name: 'Device Information', params: { iid: iid } });
	    }
	  }
	};

/***/ },
/* 118 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'Settings',
	  data: function data() {
	    return {
	      device: {
	        id: null,
	        fbid: null,
	        name: null,
	        email: null,
	        license: null,
	        phone: null,
	        taxi: null
	      }
	    };
	  },
	  computed: {
	    store: function store() {
	      return this.$parent.$store;
	    }
	  },
	  mounted: function mounted() {
	    this.getdriver();
	  },
	  methods: {
	    getdriver: function getdriver() {
	      var state = this.store.state;
	      var iid = this.$route.params.iid;
	      var self = this;
	
	      var url = state.serverURI + 'api/a/device-list/' + iid;
	
	      this.$http.get(url).then(function (response) {
	        self.device = response.data;
	      }, function (response) {});
	    }
	  }
	};

/***/ },
/* 119 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'Settings',
	  data: function data() {
	    return {
	      driver: {
	        id: null,
	        name: null,
	        email: null,
	        license: null,
	        phone: null,
	        taxi: null
	      }
	    };
	  },
	  computed: {
	    store: function store() {
	      return this.$parent.$store;
	    }
	  },
	  mounted: function mounted() {
	    this.getdriver();
	  },
	  methods: {
	    getdriver: function getdriver() {
	      var state = this.store.state;
	      var fbid = this.$route.params.fbid;
	      var self = this;
	
	      var url = state.serverURI + 'api/getDriver/' + fbid;
	
	      this.$http.get(url).then(function (response) {
	        self.driver = response.data;
	      }, function (response) {});
	    },
	    deleteDriver: function deleteDriver() {
	      var state = this.store.state;
	      var self = this;
	      var url = state.serverURI + 'api/updateDriver/';
	      this.$http.post(url, self.driver).then(function (response) {
	        if (response.status == 200) {
	          self.$router.push({ 'name': 'Driver List' });
	        }
	      }, function (response) {});
	    }
	  }
	};

/***/ },
/* 120 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'Settings',
	  data: function data() {
	    return {
	      driver: {
	        id: null,
	        fbid: null,
	        name: null,
	        email: null,
	        license: null,
	        phone: null,
	        taxi: null
	      }
	    };
	  },
	  computed: {
	    store: function store() {
	      return this.$parent.$store;
	    }
	  },
	  mounted: function mounted() {
	    this.getdriver();
	  },
	  methods: {
	    getdriver: function getdriver() {
	      var state = this.store.state;
	      var fbid = this.$route.params.fbid;
	      var self = this;
	
	      var url = state.serverURI + 'api/a/driver-list/' + fbid;
	
	      this.$http.get(url).then(function (response) {
	        self.driver = response.data;
	      }, function (response) {});
	    },
	    updateDriver: function updateDriver() {
	      var state = this.store.state;
	      var self = this;
	      var fbid = this.$route.params.fbid;
	      var url = state.serverURI + 'api/a/driver-list/' + fbid;
	      this.$http.post(url, self.driver).then(function (response) {
	        if (response.status == 200) {
	          self.$router.push({ 'name': 'Driver List' });
	        }
	      }, function (response) {});
	    }
	  }
	};

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(4);
	__webpack_require__(3);
	module.exports = {
	  name: 'Tables',
	  data: function data() {
	    return {
	      showModal: false
	    };
	  },
	  mounted: function mounted() {
	    var state = this.$store.state;
	    var store = this.$store;
	    var self = this;
	
	    this.$nextTick(function () {
	      (0, _jquery2.default)('#example1 tbody').on('click', 'a', function () {
	        if ((0, _jquery2.default)(this).attr('class') == "edit") {
	          self.driverEdit((0, _jquery2.default)(this).attr('id'));
	        } else if ((0, _jquery2.default)(this).attr('class') == "delete") {
	          self.driverDelete((0, _jquery2.default)(this).attr('id'));
	        }
	      });
	      (0, _jquery2.default)('#example1').DataTable({
	        'processing': true,
	        'serverSide': true,
	        'aaSorting': [[1, 'asc']],
	        "ajax": {
	          "url": state.serverURI + 'api/a/driver-list',
	          "dataType": 'json',
	          "type": "GET",
	          "beforeSend": function beforeSend(xhr) {
	            xhr.setRequestHeader("Authorization", 'fb ' + state.user.id + ' ' + state.token);
	          },
	          'error': function error($xhr) {
	            if ($xhr.status === 401) {
	              store.dispatch('doSetToken', null);
	              store.dispatch('doSetUser', null);
	
	              if (window.localStorage) {
	                window.localStorage.removeItem('user');
	                window.localStorage.removeItem('token');
	              }
	              self.$router.push('/login');
	            }
	          }
	        },
	        "columnDefs": [{
	          "render": function render(data, type, row) {
	            return '<img src="' + data + '" style="width=300px;height=300px;" />';
	          },
	          "targets": 0,
	          "bSortable": false
	        }, {
	          "render": function render(data, type, row) {
	            return '<a href="javascript:;" class="edit" id="' + data + '" ><i class="fa fa-pencil-square-o" aria-hidden="true"></i></a><span>&nbsp;&nbsp;</span><a href="javascript:;" class="delete" id=' + data + ' ><i class="fa fa-times" aria-hidden="true"></i></a>';
	          },
	          "targets": -1,
	          "bSortable": false
	        }]
	      });
	    });
	  },
	  methods: {
	    driverEdit: function driverEdit(fbid) {
	      var self = this;
	      self.$router.push({ name: 'Driver Edit', params: { fbid: fbid } });
	    },
	    driverDelete: function driverDelete(fbid) {
	      var self = this;
	      self.$router.push({ name: 'Driver Delete', params: { fbid: fbid } });
	    }
	  }
	};

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _pusherJs = __webpack_require__(147);
	
	var _pusherJs2 = _interopRequireDefault(_pusherJs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(145);
	
	module.exports = {
	  name: 'Dash',
	  computed: {
	    store: function store() {
	      return this.$parent.$store;
	    },
	    state: function state() {
	      return this.store.state;
	    },
	    demo: function demo() {
	      var userinfo = this.store.state.user;
	      var picture = userinfo.picture;
	      var url = "";
	      if (picture && picture.data && !picture.data.is_silhouette) {
	        url = picture.data.url;
	      }
	      return {
	        displayName: userinfo.name,
	        avatar: url,
	        email: userinfo.email,
	        randomCard: "aaa"
	      };
	    },
	    year: function year() {
	      var y = new Date();
	      return y.getFullYear();
	    }
	  },
	  methods: {
	    changeloading: function changeloading() {
	      this.store.dispatch('TOGGLE_SEARCHING');
	    },
	    ClickNoti: function ClickNoti(index, id, sender) {
	      var state = this.$store.state;
	      var store = this.$store;
	      var self = this;
	      var url = state.serverURI + 'api/a/update-noti-status';
	      this.$http.post(url, { id: id }).then(function (response) {
	        self.store.state.userInfo.messages.pop(index);
	      }, function (response) {});
	    },
	    toggleMenu: function toggleMenu(event) {
	      window.$('li.pageLink').removeClass('active');
	
	      if (event.toElement.parentElement.tagName === 'A') {
	        event.toElement.parentElement.parentElement.className = 'pageLink active';
	      } else {
	        event.toElement.parentElement.className = 'pageLink active';
	      }
	    },
	    logout: function logout() {
	      var store = this.$store;
	      var self = this;
	      store.dispatch('doSetToken', null);
	      store.dispatch('doSetUser', null);
	
	      if (window.localStorage) {
	        window.localStorage.removeItem('user');
	        window.localStorage.removeItem('token');
	      }
	      self.$router.push('/login');
	    }
	  },
	  mounted: function mounted() {
	    var self = this;
	    var routename = self.$route.name;
	
	    window.$('li.pageLink').removeClass('active');
	    if (routename.indexOf("Trip") > -1) {
	      window.$('li.pageLink#trip')[0].className = 'pageLink active';
	    } else if (routename.indexOf("Driver") > -1) {
	      window.$('li.pageLink#driver')[0].className = 'pageLink active';
	    } else if (routename.indexOf("Notification") > -1) {
	      window.$('li.pageLink#notification')[0].className = 'pageLink active';
	    }
	  },
	  created: function created() {
	    var _this = this;
	
	    var state = this.$store.state;
	    var store = this.$store;
	    var self = this;
	
	    this.pusher = new _pusherJs2.default('10b1262fcb7456607ed0', {
	      cluster: 'ap1',
	      encrypted: true
	    });
	    this.pusherChannel = this.pusher.subscribe('my-channel');
	    this.pusherChannel.bind('my-event', function (data) {
	      _this.store.state.userInfo.messages.push(data);
	    });
	
	    var url = state.serverURI + 'api/a/notification?status=0';
	    this.$http.get(url).then(function (response) {
	      var data = response.body;
	      self.store.state.userInfo.messages = [];
	      data.forEach(function (val, key) {
	        var noti = {
	          "message": val.message,
	          "title": val.title,
	          "sender": val.sender,
	          "update_time": val.created,
	          "status": 0,
	          "id": val.id
	        };
	        self.store.state.userInfo.messages.push(noti);
	      });
	    }, function (response) {});
	  }
	};

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _stringify = __webpack_require__(129);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  name: 'Login',
	  data: function data(router) {
	    return {};
	  },
	  mounted: function mounted() {
	    var self = this;
	    var store = this.$store;
	    this.$nextTick(function () {
	      (function (d, s, id) {
	        var js,
	            fjs = d.getElementsByTagName(s)[0];
	        if (d.getElementById(id)) return;
	        js = d.createElement(s);js.id = id;
	        js.src = "//connect.facebook.net/en_GB/sdk.js#xfbml=1&version=v2.8";
	        fjs.parentNode.insertBefore(js, fjs);
	      })(document, 'script', 'facebook-jssdk');
	
	      window.fbAsyncInit = function () {
	        FB.init({
	          appId: '516682505174537',
	          xfbml: true,
	          version: 'v2.8'
	        });
	        self.checkLoginState();
	      };
	    });
	  },
	  methods: {
	    doLogin: function doLogin() {
	      var self = this;
	      var store = this.$store;
	      FB.login(function (response) {
	        if (response.status === 'connected') {
	          var accessToken = response.authResponse.accessToken;
	          store.dispatch('doSetToken', accessToken);
	          if (window.localStorage) window.localStorage.setItem('token', accessToken);
	          self.getUserData(response.authResponse, function () {
	            self.$router.push("/");
	          });
	        }
	      });
	    },
	    getUserData: function getUserData(data, callback) {
	      var store = this.$store;
	      FB.api('/me', 'GET', { 'fields': 'id,name,first_name,last_name,email,picture' }, function (FBResponse) {
	        store.dispatch('doSetUser', FBResponse);
	
	        if (window.localStorage) window.localStorage.setItem('user', (0, _stringify2.default)(FBResponse));
	        callback();
	      });
	    },
	    checkLoginState: function checkLoginState() {
	      var self = this;
	      var store = this.$store;
	      FB.getLoginStatus(function (response) {
	        if (response.status === 'connected') {
	          var accessToken = response.authResponse.accessToken;
	          store.dispatch('doSetToken', accessToken);
	          if (window.localStorage) window.localStorage.setItem('token', accessToken);
	          self.getUserData(response.authResponse, function () {
	            self.$router.push("/");
	          });
	        }
	      });
	    }
	  }
	};

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(4);
	__webpack_require__(3);
	
	module.exports = {
	  name: 'Tables',
	  mounted: function mounted() {
	    var state = this.$store.state;
	    var store = this.$store;
	    var self = this;
	
	    this.$nextTick(function () {
	      (0, _jquery2.default)('#trip-list tbody').on('click', 'a', function () {
	        if ((0, _jquery2.default)(this).attr('class') == "view") {
	          self.TripTimeline((0, _jquery2.default)(this).attr('id'));
	        }
	      });
	      var triptable = (0, _jquery2.default)('#trip-list').DataTable({
	        'processing': true,
	        'serverSide': true,
	        'aaSorting': [[0, 'desc']],
	        "ajax": {
	          "url": state.serverURI + 'api/a/trip-list',
	          "dataType": 'json',
	          "type": "GET",
	          "beforeSend": function beforeSend(xhr) {
	            xhr.setRequestHeader("Authorization", 'fb ' + state.user.id + ' ' + state.token);
	          },
	          'error': function error($xhr) {
	            if ($xhr.status === 401) {
	              store.dispatch('doSetToken', null);
	              store.dispatch('doSetUser', null);
	
	              if (window.localStorage) {
	                window.localStorage.removeItem('user');
	                window.localStorage.removeItem('token');
	              }
	              self.$router.push('/login');
	            }
	          }
	        }, "columnDefs": [{
	          "render": function render(data, type, row) {
	            return '<a href="javascript:;" class="view" id="' + data + '" ><i class="fa fa-list-alt" aria-hidden="true"></i></a>';
	          },
	          "targets": -1,
	          "bSortable": false
	        }, {
	          "render": function render(data, type, row) {
	            if (data == 1) {
	              return 'Cancel';
	            }
	            return 'Complete';
	          },
	          "targets": -2,
	          "bSortable": false
	        }]
	      });
	
	      (0, _jquery2.default)(".search-text").on('keyup', function () {
	        triptable.column(this.id).search(this.value).draw();
	      });
	      (0, _jquery2.default)(".search-select").on('change', function () {
	        triptable.column(this.id).search(this.value).draw();
	      });
	    });
	  }, methods: {
	    TripTimeline: function TripTimeline(id) {
	      var self = this;
	      self.$router.push({ name: 'Trip Timeline', params: { id: id } });
	    }
	  }
	};

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		data: function data() {
			return {
				origin_input: null,
				destination_input: null,
				origin_lat: 16.860408,
				origin_lng: 96.194906,
				destination_lat: 16.960408,
				destination_lng: 96.194906
			};
		},
		mounted: function mounted() {
			var self = this;
			var origin_place_id = null;
			var destination_place_id = null;
			var travel_mode = 'DRIVING';
			var map = new google.maps.Map(document.getElementById('map'), {
				mapTypeControl: false,
				center: { lat: 16.860408, lng: 96.194906 },
				zoom: 13
			});
			var directionsService = new google.maps.DirectionsService();
			var directionsDisplay = new google.maps.DirectionsRenderer({
				draggable: true,
	
				map: map
			});
			directionsDisplay.setMap(map);
			var origin_input = document.getElementById('origin-input');
			var destination_input = document.getElementById('destination-input');
			var budget_input = document.getElementById('budget-input');
			var call_input = document.getElementById('call-button');
	
			map.controls[google.maps.ControlPosition.LEFT_TOP].push(origin_input);
			map.controls[google.maps.ControlPosition.LEFT_TOP].push(destination_input);
			map.controls[google.maps.ControlPosition.LEFT_TOP].push(budget_input);
			map.controls[google.maps.ControlPosition.LEFT_TOP].push(call_input);
			var options = {
				componentRestrictions: { country: 'MM' }
			};
			var origin_autocomplete = new google.maps.places.Autocomplete(origin_input, options);
			origin_autocomplete.bindTo('bounds', map);
			var destination_autocomplete = new google.maps.places.Autocomplete(destination_input, options);
			destination_autocomplete.bindTo('bounds', map);
	
			function expandViewportToFitPlace(map, place) {
				if (place.geometry.viewport) {
					map.fitBounds(place.geometry.viewport);
				} else {
					map.setCenter(place.geometry.location);
					map.setZoom(17);
				}
			}
	
			origin_autocomplete.addListener('place_changed', function () {
				var place = origin_autocomplete.getPlace();
				if (!place.geometry) {
					window.alert("Autocomplete's returned place contains no geometry");
					return;
				}
				self.origin_lat = place.geometry.location.lat();
				self.origin_lng = place.geometry.location.lng();
	
				expandViewportToFitPlace(map, place);
	
				origin_place_id = place.place_id;
				route(origin_place_id, destination_place_id, travel_mode, directionsService, directionsDisplay, map);
			});
	
			destination_autocomplete.addListener('place_changed', function () {
				var place = destination_autocomplete.getPlace();
				if (!place.geometry) {
					window.alert("Autocomplete's returned place contains no geometry");
					return;
				}
				self.destination_lat = place.geometry.location.lat();
				self.destination_lng = place.geometry.location.lng();
	
				expandViewportToFitPlace(map, place);
	
				destination_place_id = place.place_id;
				route(origin_place_id, destination_place_id, travel_mode, directionsService, directionsDisplay, map);
			});
			directionsDisplay.addListener('directions_changed', function () {
				computeTotalDistance(directionsDisplay.getDirections());
			});
			function computeTotalDistance(result) {
				var origin_input = document.getElementById('origin-input');
				var destination_input = document.getElementById('destination-input');
				var myroute = result.routes[0];
				origin_input.value = myroute.legs[0].start_address;
				destination_input.value = myroute.legs[0].end_address;
				self.origin_input = myroute.legs[0].start_address;
				self.destination_input = myroute.legs[0].end_address;
			}
			function route(origin_place_id, destination_place_id, travel_mode, directionsService, directionsDisplay, map) {
				if (!origin_place_id || !destination_place_id) {
					return;
				}
				directionsService.route({
					origin: { 'placeId': origin_place_id },
					destination: { 'placeId': destination_place_id },
					travelMode: travel_mode
				}, function (response, status) {
					if (status === 'OK') {
						directionsDisplay.setDirections(response);
					} else {
						window.alert('Directions request failed due to ' + status);
					}
				});
			}
		},
		methods: {
			callDriver: function callDriver() {
				var self = this;
				var state = this.$store.state;
				var sender = self.$route.params.sender;
				var origin_input = self.origin_input;
				var destination_input = self.destination_input;
				var budget_input = self.budget;
				if (origin_input == '' || origin_input == undefined) {
					alert('Please fill Origin');return false;
				} else if (destination_input == '' || destination_input == undefined) {
					alert('Please fill Destination');return false;
				} else if (budget_input == '' || budget_input == undefined) {
					alert('Please fill budget');return false;
				} else {
					_jquery2.default.ajax({
						url: state.serverURI + "api/a/admin-trip-request",
						type: "POST",
						data: {
							'origin_lat': self.origin_lat,
							'origin_lng': self.origin_lng,
							'destination_lat': self.destination_lat,
							'destination_lng': self.destination_lng,
							'origin_input': origin_input,
							'destination_input': destination_input,
							'budget_input': budget_input,
							'sender': sender
						},
						dataType: "json",
						complete: function complete(xhr, status) {}
					});
				}
			},
			isNumber: function isNumber(evt) {
				evt = evt ? evt : window.event;
				var charCode = evt.which ? evt.which : evt.keyCode;
				if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
					evt.preventDefault();;
				} else {
					return true;
				}
			}
		}
	};

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.count = count;
	var moment = __webpack_require__(1);
	function count(arr) {
	  return arr.length;
	}

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ = __webpack_require__(148);
	
	var _2 = _interopRequireDefault(_);
	
	var _Login = __webpack_require__(159);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	var _Home = __webpack_require__(158);
	
	var _Home2 = _interopRequireDefault(_Home);
	
	var _TripRequest = __webpack_require__(161);
	
	var _TripRequest2 = _interopRequireDefault(_TripRequest);
	
	var _TripList = __webpack_require__(160);
	
	var _TripList2 = _interopRequireDefault(_TripList);
	
	var _Driver = __webpack_require__(154);
	
	var _Driver2 = _interopRequireDefault(_Driver);
	
	var _DriverList = __webpack_require__(157);
	
	var _DriverList2 = _interopRequireDefault(_DriverList);
	
	var _DriverEdit = __webpack_require__(156);
	
	var _DriverEdit2 = _interopRequireDefault(_DriverEdit);
	
	var _DriverDelete = __webpack_require__(155);
	
	var _DriverDelete2 = _interopRequireDefault(_DriverDelete);
	
	var _Device = __webpack_require__(150);
	
	var _Device2 = _interopRequireDefault(_Device);
	
	var _DeviceList = __webpack_require__(152);
	
	var _DeviceList2 = _interopRequireDefault(_DeviceList);
	
	var _DeviceView = __webpack_require__(153);
	
	var _DeviceView2 = _interopRequireDefault(_DeviceView);
	
	var _DeviceDelete = __webpack_require__(151);
	
	var _DeviceDelete2 = _interopRequireDefault(_DeviceDelete);
	
	var _TripTimeline = __webpack_require__(162);
	
	var _TripTimeline2 = _interopRequireDefault(_TripTimeline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var routes = [{
	  path: '/login',
	  name: 'login',
	  component: _Login2.default
	}, {
	  path: '/',
	  component: _Home2.default,
	  children: [{
	    path: '',
	    component: _TripList2.default,
	    name: 'Trip List',
	    meta: { auth: true },
	    description: 'All Trip Request'
	  }, {
	    path: '/triptimeline/:id',
	    component: _TripTimeline2.default,
	    name: 'Trip Timeline',
	    meta: { auth: true },
	    description: 'All Trip Request'
	  }, {
	    path: '/driver',
	    component: _Driver2.default,
	    children: [{
	      path: '',
	      component: _DriverList2.default,
	      name: 'Driver List',
	      meta: { auth: true },
	      description: 'Overview of environment'
	    }, {
	      path: '/driver/:fbid',
	      component: _DriverEdit2.default,
	      name: 'Driver Edit',
	      meta: { auth: true },
	      description: 'Update Driver'
	    }, {
	      path: '/driverdelete/:fbid',
	      component: _DriverDelete2.default,
	      name: 'Driver Delete',
	      meta: { auth: true },
	      description: 'Delete Driver'
	    }]
	  }, {
	    path: '/device',
	    component: _Device2.default,
	    children: [{
	      path: '',
	      component: _DeviceList2.default,
	      name: 'Device List',
	      meta: { auth: true },
	      description: 'Overview of environment'
	    }, {
	      path: '/device/:iid',
	      component: _DeviceView2.default,
	      name: 'Device Information',
	      meta: { auth: true },
	      description: 'View Device'
	    }]
	  }, {
	    path: '/triprequest/:sender',
	    component: _TripRequest2.default,
	    name: 'Trip Request',
	    meta: { auth: true },
	    description: 'Admin Trip Request'
	  }]
	}, {
	  path: '*',
	  component: _2.default
	}];
	
	exports.default = routes;

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(113);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(181);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	var state = {
	  callingAPI: false,
	  searching: '',
	  serverURI: 'https://api.unitedtaxi.co/',
	
	  user: null,
	  token: null,
	  userInfo: {
	    messages: [{ message: 'test', sender: '123456789', update_time: new Date(), status: 0 }],
	    notifications: [],
	    tasks: []
	  }
	};
	
	var mutations = {
	  TOGGLE_LOADING: function TOGGLE_LOADING(state) {
	    state.callingAPI = !state.callingAPI;
	  },
	  TOGGLE_SEARCHING: function TOGGLE_SEARCHING(state) {
	    state.searching = state.searching === '' ? 'loading' : '';
	  },
	  SET_USER: function SET_USER(state, user) {
	    state.user = user;
	  },
	  SET_TOKEN: function SET_TOKEN(state, token) {
	    state.token = token;
	  }
	};
	
	var actions = {
	  doToggleLoading: function doToggleLoading(_ref, state) {
	    var commit = _ref.commit;
	
	    commit('TOGGLE_LOADING', state);
	  },
	  doToggleSearch: function doToggleSearch(_ref2, todo) {
	    var commit = _ref2.commit;
	
	    commit('TOGGLE_SEARCHING', todo);
	  },
	  doSetUser: function doSetUser(_ref3, state, user) {
	    var commit = _ref3.commit;
	
	    commit('SET_USER', state, user);
	  },
	  doSetToken: function doSetToken(_ref4, state, token) {
	    var commit = _ref4.commit;
	
	    commit('SET_TOKEN', state, token);
	  }
	};
	
	exports.default = new _vuex2.default.Store({
	  state: state,
	  mutations: mutations,
	  actions: actions
	});

/***/ },
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 134 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 135 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 136 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 137 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 138 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 139 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 140 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 141 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 142 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 143 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 144 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 145 */,
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 5,
		"./af.js": 5,
		"./ar": 11,
		"./ar-dz": 6,
		"./ar-dz.js": 6,
		"./ar-ly": 7,
		"./ar-ly.js": 7,
		"./ar-ma": 8,
		"./ar-ma.js": 8,
		"./ar-sa": 9,
		"./ar-sa.js": 9,
		"./ar-tn": 10,
		"./ar-tn.js": 10,
		"./ar.js": 11,
		"./az": 12,
		"./az.js": 12,
		"./be": 13,
		"./be.js": 13,
		"./bg": 14,
		"./bg.js": 14,
		"./bn": 15,
		"./bn.js": 15,
		"./bo": 16,
		"./bo.js": 16,
		"./br": 17,
		"./br.js": 17,
		"./bs": 18,
		"./bs.js": 18,
		"./ca": 19,
		"./ca.js": 19,
		"./cs": 20,
		"./cs.js": 20,
		"./cv": 21,
		"./cv.js": 21,
		"./cy": 22,
		"./cy.js": 22,
		"./da": 23,
		"./da.js": 23,
		"./de": 25,
		"./de-at": 24,
		"./de-at.js": 24,
		"./de.js": 25,
		"./dv": 26,
		"./dv.js": 26,
		"./el": 27,
		"./el.js": 27,
		"./en-au": 28,
		"./en-au.js": 28,
		"./en-ca": 29,
		"./en-ca.js": 29,
		"./en-gb": 30,
		"./en-gb.js": 30,
		"./en-ie": 31,
		"./en-ie.js": 31,
		"./en-nz": 32,
		"./en-nz.js": 32,
		"./eo": 33,
		"./eo.js": 33,
		"./es": 35,
		"./es-do": 34,
		"./es-do.js": 34,
		"./es.js": 35,
		"./et": 36,
		"./et.js": 36,
		"./eu": 37,
		"./eu.js": 37,
		"./fa": 38,
		"./fa.js": 38,
		"./fi": 39,
		"./fi.js": 39,
		"./fo": 40,
		"./fo.js": 40,
		"./fr": 43,
		"./fr-ca": 41,
		"./fr-ca.js": 41,
		"./fr-ch": 42,
		"./fr-ch.js": 42,
		"./fr.js": 43,
		"./fy": 44,
		"./fy.js": 44,
		"./gd": 45,
		"./gd.js": 45,
		"./gl": 46,
		"./gl.js": 46,
		"./he": 47,
		"./he.js": 47,
		"./hi": 48,
		"./hi.js": 48,
		"./hr": 49,
		"./hr.js": 49,
		"./hu": 50,
		"./hu.js": 50,
		"./hy-am": 51,
		"./hy-am.js": 51,
		"./id": 52,
		"./id.js": 52,
		"./is": 53,
		"./is.js": 53,
		"./it": 54,
		"./it.js": 54,
		"./ja": 55,
		"./ja.js": 55,
		"./jv": 56,
		"./jv.js": 56,
		"./ka": 57,
		"./ka.js": 57,
		"./kk": 58,
		"./kk.js": 58,
		"./km": 59,
		"./km.js": 59,
		"./ko": 60,
		"./ko.js": 60,
		"./ky": 61,
		"./ky.js": 61,
		"./lb": 62,
		"./lb.js": 62,
		"./lo": 63,
		"./lo.js": 63,
		"./lt": 64,
		"./lt.js": 64,
		"./lv": 65,
		"./lv.js": 65,
		"./me": 66,
		"./me.js": 66,
		"./mi": 67,
		"./mi.js": 67,
		"./mk": 68,
		"./mk.js": 68,
		"./ml": 69,
		"./ml.js": 69,
		"./mr": 70,
		"./mr.js": 70,
		"./ms": 72,
		"./ms-my": 71,
		"./ms-my.js": 71,
		"./ms.js": 72,
		"./my": 73,
		"./my.js": 73,
		"./nb": 74,
		"./nb.js": 74,
		"./ne": 75,
		"./ne.js": 75,
		"./nl": 77,
		"./nl-be": 76,
		"./nl-be.js": 76,
		"./nl.js": 77,
		"./nn": 78,
		"./nn.js": 78,
		"./pa-in": 79,
		"./pa-in.js": 79,
		"./pl": 80,
		"./pl.js": 80,
		"./pt": 82,
		"./pt-br": 81,
		"./pt-br.js": 81,
		"./pt.js": 82,
		"./ro": 83,
		"./ro.js": 83,
		"./ru": 84,
		"./ru.js": 84,
		"./se": 85,
		"./se.js": 85,
		"./si": 86,
		"./si.js": 86,
		"./sk": 87,
		"./sk.js": 87,
		"./sl": 88,
		"./sl.js": 88,
		"./sq": 89,
		"./sq.js": 89,
		"./sr": 91,
		"./sr-cyrl": 90,
		"./sr-cyrl.js": 90,
		"./sr.js": 91,
		"./ss": 92,
		"./ss.js": 92,
		"./sv": 93,
		"./sv.js": 93,
		"./sw": 94,
		"./sw.js": 94,
		"./ta": 95,
		"./ta.js": 95,
		"./te": 96,
		"./te.js": 96,
		"./tet": 97,
		"./tet.js": 97,
		"./th": 98,
		"./th.js": 98,
		"./tl-ph": 99,
		"./tl-ph.js": 99,
		"./tlh": 100,
		"./tlh.js": 100,
		"./tr": 101,
		"./tr.js": 101,
		"./tzl": 102,
		"./tzl.js": 102,
		"./tzm": 104,
		"./tzm-latn": 103,
		"./tzm-latn.js": 103,
		"./tzm.js": 104,
		"./uk": 105,
		"./uk.js": 105,
		"./uz": 106,
		"./uz.js": 106,
		"./vi": 107,
		"./vi.js": 107,
		"./x-pseudo": 108,
		"./x-pseudo.js": 108,
		"./yo": 109,
		"./yo.js": 109,
		"./zh-cn": 110,
		"./zh-cn.js": 110,
		"./zh-hk": 111,
		"./zh-hk.js": 111,
		"./zh-tw": 112,
		"./zh-tw.js": 112
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 146;


/***/ },
/* 147 */,
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(135)
	
	/* script */
	__vue_exports__ = __webpack_require__(114)
	
	/* template */
	var __vue_template__ = __webpack_require__(166)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(115)
	
	/* template */
	var __vue_template__ = __webpack_require__(168)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* template */
	var __vue_template__ = __webpack_require__(164)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(141)
	
	/* script */
	__vue_exports__ = __webpack_require__(116)
	
	/* template */
	var __vue_template__ = __webpack_require__(173)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(142)
	
	/* script */
	__vue_exports__ = __webpack_require__(117)
	
	/* template */
	var __vue_template__ = __webpack_require__(174)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(144)
	
	/* script */
	__vue_exports__ = __webpack_require__(118)
	
	/* template */
	var __vue_template__ = __webpack_require__(176)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* template */
	var __vue_template__ = __webpack_require__(177)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(133)
	
	/* script */
	__vue_exports__ = __webpack_require__(119)
	
	/* template */
	var __vue_template__ = __webpack_require__(163)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(138)
	
	/* script */
	__vue_exports__ = __webpack_require__(120)
	
	/* template */
	var __vue_template__ = __webpack_require__(170)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(139)
	
	/* script */
	__vue_exports__ = __webpack_require__(121)
	
	/* template */
	var __vue_template__ = __webpack_require__(171)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(140)
	
	/* script */
	__vue_exports__ = __webpack_require__(122)
	
	/* template */
	var __vue_template__ = __webpack_require__(172)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(134)
	
	/* script */
	__vue_exports__ = __webpack_require__(123)
	
	/* template */
	var __vue_template__ = __webpack_require__(165)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(137)
	
	/* script */
	__vue_exports__ = __webpack_require__(124)
	
	/* template */
	var __vue_template__ = __webpack_require__(169)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(136)
	
	/* script */
	__vue_exports__ = __webpack_require__(125)
	
	/* template */
	var __vue_template__ = __webpack_require__(167)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(143)
	
	/* template */
	var __vue_template__ = __webpack_require__(175)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 163 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', [_c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-info"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.driver.id),
	      expression: "driver.id"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "hidden"
	    },
	    domProps: {
	      "value": _vm._s(_vm.driver.id)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.driver.id = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('span', {
	    staticClass: "input-group-addon"
	  }, [_vm._v("@")]), _vm._v(" "), _c('span', {
	    staticClass: "form-control"
	  }, [_vm._v(_vm._s(_vm.driver.name))])]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_vm._m(1), _vm._v(" "), _c('span', {
	    staticClass: "form-control"
	  }, [_vm._v(_vm._s(_vm.driver.email))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_vm._m(2), _vm._v(" "), _c('span', {
	    staticClass: "form-control"
	  }, [_vm._v(_vm._s(_vm.driver.license))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_vm._m(3), _vm._v(" "), _c('span', {
	    staticClass: "form-control"
	  }, [_vm._v(_vm._s(_vm.driver.phone))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_vm._m(4), _vm._v(" "), _c('span', {
	    staticClass: "form-control"
	  }, [_vm._v(_vm._s(_vm.driver.taxi))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-lg",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.deleteDriver
	    }
	  }, [_vm._v("Delete")])]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" ")]), _vm._v(" ")])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Personal Information")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('span', {
	    staticClass: "input-group-addon"
	  }, [_c('i', {
	    staticClass: "fa fa-envelope"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('span', {
	    staticClass: "input-group-addon"
	  }, [_c('i', {
	    staticClass: "fa fa-id-card-o"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('span', {
	    staticClass: "input-group-addon"
	  }, [_c('i', {
	    staticClass: "fa fa-tablet"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('span', {
	    staticClass: "input-group-addon"
	  }, [_c('i', {
	    staticClass: "fa fa-taxi"
	  })])
	}]}

/***/ },
/* 164 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', [_c('router-view')])
	},staticRenderFns: []}

/***/ },
/* 165 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', {
	    staticClass: "container container-table"
	  }, [_c('div', {
	    staticClass: "row vertical-10p"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('img', {
	    staticClass: "center-block logo",
	    attrs: {
	      "src": "static/img/logo.png"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "text-center col-md-4 col-sm-offset-4"
	  }, [(_vm.response) ? _c('div', {
	    staticClass: "text-red"
	  }, [_c('p', [_vm._v(_vm._s(_vm.response))])]) : _vm._e(), _vm._v(" "), _vm._v(" "), _c('a', {
	    staticClass: "btn btn-block btn-social btn-facebook btn-flat",
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": _vm.doLogin
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-facebook"
	  }), _vm._v(" Sign in using Facebook\n\t          ")])])])])])
	},staticRenderFns: []}

/***/ },
/* 166 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', {
	    staticClass: "container container-table"
	  }, [_c('div', {
	    staticClass: "row vertical-10p"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('img', {
	    staticClass: "center-block logo",
	    attrs: {
	      "src": "static/img/logo.png"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "text-center col-sm-6 col-sm-offset-3"
	  }, [_c('h1', [_vm._v("You are lost.")]), _vm._v(" "), _c('h4', [_vm._v("This page doesn't exist.")]), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'Trip Request'
	      }
	    }
	  }, [_vm._v("Take me home.")])])])])])
	},staticRenderFns: []}

/***/ },
/* 167 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('section', {
	    staticClass: "content"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.origin),
	      expression: "origin"
	    }],
	    staticClass: "controls",
	    attrs: {
	      "id": "origin-input",
	      "type": "text",
	      "placeholder": "Enter an origin location"
	    },
	    domProps: {
	      "value": _vm._s(_vm.origin)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.origin = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.destination),
	      expression: "destination"
	    }],
	    staticClass: "controls",
	    attrs: {
	      "id": "destination-input",
	      "type": "text",
	      "placeholder": "Enter a destination location"
	    },
	    domProps: {
	      "value": _vm._s(_vm.destination)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.destination = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.budget),
	      expression: "budget"
	    }],
	    staticClass: "controls",
	    attrs: {
	      "id": "budget-input",
	      "type": "text",
	      "placeholder": "Enter budget"
	    },
	    domProps: {
	      "value": _vm._s(_vm.budget)
	    },
	    on: {
	      "keypress": function($event) {
	        _vm.isNumber(_vm.evt)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.budget = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "controls",
	    attrs: {
	      "type": "button",
	      "id": "call-button"
	    },
	    on: {
	      "click": _vm.callDriver
	    }
	  }, [_vm._v("Call Driver Now!")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "map"
	    }
	  })])
	},staticRenderFns: []}

/***/ },
/* 168 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', [_c('router-view')])
	},staticRenderFns: []}

/***/ },
/* 169 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row center-block"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }), _vm._v(" "), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
	    attrs: {
	      "id": "example1_wrapper"
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('table', {
	    staticClass: "table table-bordered table-striped dataTable",
	    attrs: {
	      "aria-describedby": "example1_info",
	      "role": "grid",
	      "id": "trip-list"
	    }
	  }, [_vm._m(1), _vm._v(" "), _c('tbody'), _vm._v(" "), _c('tfoot', [_c('tr', [_c('th', {
	    attrs: {
	      "colspan": "1",
	      "rowspan": "1"
	    }
	  }, [_vm._v("Update Time")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "colspan": "1",
	      "rowspan": "1"
	    }
	  }, [_vm._v("Pickup Point")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "colspan": "1",
	      "rowspan": "1"
	    }
	  }, [_vm._v("Dropoff Point")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "colspan": "1",
	      "rowspan": "1"
	    }
	  }, [_vm._v("Budget")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "colspan": "1",
	      "rowspan": "1"
	    }
	  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "colspan": "1",
	      "rowspan": "1"
	    }
	  }, [_vm._v("Action")])])])])])])]), _vm._v(" ")])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-6"
	  }, [_c('div', {
	    staticClass: "dataTables_length",
	    attrs: {
	      "id": "example1_length"
	    }
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('thead', [_c('tr', {
	    attrs: {
	      "role": "row"
	    }
	  }, [_c('th', [_c('input', {
	    staticClass: "search-text",
	    attrs: {
	      "id": "0",
	      "type": "text",
	      "placeholder": "Search"
	    }
	  })]), _vm._v(" "), _c('th', [_c('input', {
	    staticClass: "search-text",
	    attrs: {
	      "id": "1",
	      "type": "text",
	      "placeholder": "Search"
	    }
	  })]), _vm._v(" "), _c('th', [_c('input', {
	    staticClass: "search-text",
	    attrs: {
	      "id": "2",
	      "type": "text",
	      "placeholder": "Search"
	    }
	  })]), _vm._v(" "), _c('th', [_c('input', {
	    staticClass: "search-text",
	    attrs: {
	      "id": "3",
	      "type": "text",
	      "placeholder": "Search"
	    }
	  })]), _vm._v(" "), _c('th', [_c('select', {
	    staticClass: "search-select",
	    attrs: {
	      "id": "4"
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": ""
	    }
	  }, [_vm._v("..")]), _c('option', {
	    attrs: {
	      "value": "0"
	    }
	  }, [_vm._v("Done")]), _c('option', {
	    attrs: {
	      "value": "1"
	    }
	  }, [_vm._v("Cancel")])])]), _vm._v(" "), _c('th')]), _vm._v(" "), _c('tr', {
	    attrs: {
	      "role": "row"
	    }
	  }, [_c('th', [_vm._v("Update Time")]), _vm._v(" "), _c('th', [_vm._v("Pickup Address")]), _vm._v(" "), _c('th', [_vm._v("Drop-off Address")]), _vm._v(" "), _c('th', [_vm._v("Budget")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Action")])])])
	}]}

/***/ },
/* 170 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', [_c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-info"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('span', {
	    staticClass: "input-group-addon"
	  }, [_vm._v("@")]), _vm._v(" "), _c('span', {
	    staticClass: "form-control"
	  }, [_vm._v(_vm._s(_vm.driver.name))])]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_vm._m(1), _vm._v(" "), _c('span', {
	    staticClass: "form-control"
	  }, [_vm._v(_vm._s(_vm.driver.email))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_vm._m(2), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.driver.license),
	      expression: "driver.license"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": _vm._s(_vm.driver.license)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.driver.license = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_vm._m(3), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.driver.phone),
	      expression: "driver.phone"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": _vm._s(_vm.driver.phone)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.driver.phone = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_vm._m(4), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.driver.taxi),
	      expression: "driver.taxi"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": _vm._s(_vm.driver.taxi)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.driver.taxi = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-lg",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.updateDriver
	    }
	  }, [_vm._v("Update")])]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" ")]), _vm._v(" ")])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Personal Information")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('span', {
	    staticClass: "input-group-addon"
	  }, [_c('i', {
	    staticClass: "fa fa-envelope"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('span', {
	    staticClass: "input-group-addon"
	  }, [_c('i', {
	    staticClass: "fa fa-credit-card"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('span', {
	    staticClass: "input-group-addon"
	  }, [_c('i', {
	    staticClass: "fa fa-tablet"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('span', {
	    staticClass: "input-group-addon"
	  }, [_c('i', {
	    staticClass: "fa fa-taxi"
	  })])
	}]}

/***/ },
/* 171 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row center-block"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }), _vm._v(" "), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
	    attrs: {
	      "id": "example1_wrapper"
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('table', {
	    staticClass: "table table-bordered table-striped dataTable",
	    attrs: {
	      "aria-describedby": "example1_info",
	      "role": "grid",
	      "id": "example1"
	    }
	  }, [_vm._m(1), _vm._v(" "), _c('tbody'), _vm._v(" "), _c('tfoot', [_c('tr', [_c('th', {
	    attrs: {
	      "colspan": "1",
	      "rowspan": "1"
	    }
	  }), _vm._v(" "), _c('th', {
	    attrs: {
	      "colspan": "1",
	      "rowspan": "1"
	    }
	  }, [_vm._v("Name")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "colspan": "1",
	      "rowspan": "1"
	    }
	  }, [_vm._v("Email")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "colspan": "1",
	      "rowspan": "1"
	    }
	  }, [_vm._v("Driver License")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "colspan": "1",
	      "rowspan": "1"
	    }
	  }, [_vm._v("Taxi Plate")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "colspan": "1",
	      "rowspan": "1"
	    }
	  }, [_vm._v("Phone")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "colspan": "1",
	      "rowspan": "1"
	    }
	  }, [_vm._v("Action")])])])])])])]), _vm._v(" ")])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-6"
	  }, [_c('div', {
	    staticClass: "dataTables_length",
	    attrs: {
	      "id": "example1_length"
	    }
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('thead', [_c('tr', {
	    attrs: {
	      "role": "row"
	    }
	  }, [_c('th'), _vm._v(" "), _c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Email")]), _vm._v(" "), _c('th', [_vm._v("Driver License")]), _vm._v(" "), _c('th', [_vm._v("Taxi Plate")]), _vm._v(" "), _c('th', [_vm._v("Phone")]), _vm._v(" "), _c('th', [_vm._v("Action")])])])
	}]}

/***/ },
/* 172 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', {
	    staticClass: "wrapper"
	  }, [_c('header', {
	    staticClass: "main-header"
	  }, [_vm._m(0), _vm._v(" "), _vm._v(" "), _c('nav', {
	    staticClass: "navbar navbar-static-top",
	    attrs: {
	      "role": "navigation"
	    }
	  }, [_vm._m(1), _vm._v(" "), _vm._v(" "), _c('div', {
	    staticClass: "navbar-custom-menu"
	  }, [_c('ul', {
	    staticClass: "nav navbar-nav"
	  }, [_c('li', {
	    staticClass: "dropdown messages-menu"
	  }, [_c('a', {
	    staticClass: "dropdown-toggle",
	    attrs: {
	      "href": "javascript:;",
	      "data-toggle": "dropdown"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-envelope-o"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "label label-success"
	  }, [_vm._v(_vm._s(_vm._f("count")(_vm.state.userInfo.messages)))])]), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu"
	  }, [_c('li', {
	    staticClass: "header"
	  }, [_vm._v("You have " + _vm._s(_vm._f("count")(_vm.state.userInfo.messages)) + " message(s)")]), _vm._v(" "), (_vm.state.userInfo.messages.length > 0) ? _c('li', [_c('ul', {
	    staticClass: "menu"
	  }, [_vm._l((_vm.state.userInfo.messages), function(item, key, index) {
	    return _c('li', [_c('a', {
	      attrs: {
	        "id": ""
	      },
	      on: {
	        "click": function($event) {
	          _vm.ClickNoti(index, item.id, item.sender)
	        }
	      }
	    }, [_c('h4', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(item.title) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t"), _c('small', [_c('i', {
	      staticClass: "fa fa-clock-o"
	    }), _c('span', [_vm._v(_vm._s(_vm._f("moment")(item.update_time, 'from', 'now')))])])]), _vm._v(" "), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.message))]), _vm._v(" ")])])
	  }), _vm._v(" ")], true), _vm._v(" ")]) : _vm._e(), _vm._v(" "), (_vm.state.userInfo.messages.length > 0) ? _c('li', {
	    staticClass: "footer"
	  }, [_c('a', {
	    attrs: {
	      "href": "javascript:;"
	    }
	  }, [_vm._v("See All Messages")])]) : _vm._e()])]), _vm._v(" "), _vm._v(" "), _vm._v(" "), _c('li', {
	    staticClass: "dropdown notifications-menu"
	  }, [_c('a', {
	    staticClass: "dropdown-toggle",
	    attrs: {
	      "href": "javascript:;",
	      "data-toggle": "dropdown"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-bell-o"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "label label-warning"
	  }, [_vm._v(_vm._s(_vm._f("count")(_vm.state.userInfo.notifications)))])]), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu"
	  }, [_c('li', {
	    staticClass: "header"
	  }, [_vm._v("You have " + _vm._s(_vm._f("count")(_vm.state.userInfo.notifications)) + " notification(s)")]), _vm._v(" "), (_vm.state.userInfo.notifications.length > 0) ? _c('li', [_vm._m(2)]) : _vm._e(), _vm._v(" "), (_vm.state.userInfo.notifications.length > 0) ? _c('li', {
	    staticClass: "footer"
	  }, [_c('a', {
	    attrs: {
	      "href": "javascript:;"
	    }
	  }, [_vm._v("View all")])]) : _vm._e()])]), _vm._v(" "), _vm._v(" "), _c('li', {
	    staticClass: "dropdown tasks-menu"
	  }, [_c('a', {
	    staticClass: "dropdown-toggle",
	    attrs: {
	      "href": "javascript:;",
	      "data-toggle": "dropdown"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-flag-o"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(_vm._s(_vm._f("count")(_vm.state.userInfo.tasks)) + " ")])]), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu"
	  }, [_c('li', {
	    staticClass: "header"
	  }, [_vm._v("You have " + _vm._s(_vm._f("count")(_vm.state.userInfo.tasks)) + "  task(s)")]), _vm._v(" "), (_vm.state.userInfo.tasks.length > 0) ? _c('li', [_vm._m(3)]) : _vm._e(), _vm._v(" "), (_vm.state.userInfo.tasks.length > 0) ? _c('li', {
	    staticClass: "footer"
	  }, [_c('a', {
	    attrs: {
	      "href": "javascript:;"
	    }
	  }, [_vm._v("View all tasks")])]) : _vm._e()])]), _vm._v(" "), _vm._v(" "), _c('li', {
	    staticClass: "dropdown user user-menu"
	  }, [_c('a', {
	    staticClass: "dropdown-toggle",
	    attrs: {
	      "href": "javascript:;",
	      "data-toggle": "dropdown"
	    }
	  }, [_c('img', {
	    staticClass: "user-image",
	    attrs: {
	      "src": _vm.demo.avatar,
	      "alt": "User Image"
	    }
	  }), _vm._v(" "), _vm._v(" "), _c('span', {
	    staticClass: "hidden-xs"
	  }, [_vm._v(_vm._s(_vm.demo.displayName))])]), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu"
	  }, [(_vm.demo.displayName != '') ? _c('li', [_c('a', {
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": _vm.logout
	    }
	  }, [_vm._m(4)])]) : _vm._e()])])])])])]), _vm._v(" "), _vm._v(" "), _c('aside', {
	    staticClass: "main-sidebar"
	  }, [_c('section', {
	    staticClass: "sidebar"
	  }, [_c('div', {
	    staticClass: "user-panel"
	  }, [_c('div', {
	    staticClass: "pull-left image"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "pull-left info"
	  }, [_c('div', [_c('p', {
	    staticClass: "white"
	  }, [_vm._v(_vm._s(_vm.demo.displayName))])]), _vm._v(" "), _vm._m(5)])]), _vm._v(" "), _vm._v(" "), _c('ul', {
	    staticClass: "sidebar-menu"
	  }, [_c('li', {
	    staticClass: "header"
	  }, [_vm._v("TOOLS")]), _vm._v(" "), _c('li', {
	    staticClass: "pageLink active",
	    attrs: {
	      "id": "trip"
	    },
	    on: {
	      "click": _vm.toggleMenu
	    }
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'Trip List'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-road"
	  }), _c('span', {
	    staticClass: "page"
	  }, [_vm._v("Trip List")])])]), _vm._v(" "), _c('li', {
	    staticClass: "pageLink",
	    attrs: {
	      "id": "driver"
	    },
	    on: {
	      "click": _vm.toggleMenu
	    }
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'Driver List'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-taxi"
	  }), _c('span', {
	    staticClass: "page"
	  }, [_vm._v("Driver List")])])]), _vm._v(" "), _c('li', {
	    staticClass: "pageLink",
	    attrs: {
	      "id": "device"
	    },
	    on: {
	      "click": _vm.toggleMenu
	    }
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'Device List'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-mobile"
	  }), _c('span', {
	    staticClass: "page"
	  }, [_vm._v("Device List")])])]), _vm._v(" "), _c('li', {
	    staticClass: "pageLink",
	    attrs: {
	      "id": "map"
	    },
	    on: {
	      "click": _vm.toggleMenu
	    }
	  }, [_vm._m(6)]), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" ")]), _vm._v(" ")]), _vm._v(" ")]), _vm._v(" "), _vm._v(" "), _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.$route.name) + "\n\t\t\t\t\t"), _c('small', [_vm._v(_vm._s(_vm.$route.description))])]), _vm._v(" "), _c('ol', {
	    staticClass: "breadcrumb"
	  }, [_vm._m(7), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v(_vm._s(_vm.$route.name))])])]), _vm._v(" "), _c('router-view')]), _vm._v(" "), _vm._v(" "), _vm._v(" "), _c('footer', {
	    staticClass: "main-footer"
	  }, [_c('strong', [_vm._v("Copyright © " + _vm._s(_vm.year) + " "), _c('a', {
	    attrs: {
	      "href": "javascript:;"
	    }
	  }, [_vm._v("United Taxi")]), _vm._v(".")]), _vm._v(" All rights reserved.\n\t\t")])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('a', {
	    staticClass: "logo",
	    attrs: {
	      "href": "/"
	    }
	  }, [_c('span', {
	    staticClass: "logo-mini"
	  }, [_c('img', {
	    staticClass: "img-responsive center-block",
	    attrs: {
	      "src": "/static/img/logo_sm.png",
	      "alt": "Logo"
	    }
	  })]), _vm._v(" "), _vm._v(" "), _c('div', {
	    staticClass: "container logo-lg"
	  }, [_c('div', {
	    staticClass: "pull-left image"
	  }, [_c('img', {
	    staticClass: "img-responsive",
	    attrs: {
	      "src": "/static/img/logo_sm.png",
	      "alt": "Logo"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "pull-left info"
	  }, [_vm._v("United Taxi")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('a', {
	    staticClass: "sidebar-toggle",
	    attrs: {
	      "href": "javascript:;",
	      "data-toggle": "offcanvas",
	      "role": "button"
	    }
	  }, [_c('span', {
	    staticClass: "sr-only"
	  }, [_vm._v("Toggle navigation")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('ul', {
	    staticClass: "menu"
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "javascript:;"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-users text-aqua"
	  }), _vm._v(" 5 new members joined today\n\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('ul', {
	    staticClass: "menu"
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "javascript:;"
	    }
	  }, [_c('h3', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\tDesign some buttons\n\t\t\t\t\t\t\t\t\t\t\t\t\t"), _c('small', {
	    staticClass: "pull-right"
	  }, [_vm._v("20%")])]), _vm._v(" "), _vm._v(" "), _c('div', {
	    staticClass: "progress xs"
	  }, [_c('div', {
	    staticClass: "progress-bar progress-bar-aqua",
	    staticStyle: {
	      "width": "20%"
	    },
	    attrs: {
	      "role": "progressbar",
	      "aria-valuenow": "20",
	      "aria-valuemin": "0",
	      "aria-valuemax": "100"
	    }
	  }, [_c('span', {
	    staticClass: "sr-only"
	  }, [_vm._v("20% Complete")])])])])]), _vm._v(" ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('h4', [_c('i', {
	    staticClass: "fa fa-sign-out text-aqua"
	  }), _vm._v(" Log Out\n\t\t\t\t\t\t\t\t\t\t")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('a', {
	    attrs: {
	      "href": "javascript:;"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-circle text-success"
	  }), _vm._v(" Online")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('a', {
	    attrs: {
	      "target": "_blank",
	      "href": "/static/admin/index.html"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-map-marker"
	  }), _c('span', {
	    staticClass: "page"
	  }, [_vm._v("Map View")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('li', [_c('a', {
	    attrs: {
	      "href": "javascript:;"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-home"
	  }), _vm._v("Home")])])
	}]}

/***/ },
/* 173 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', [_c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-info"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.driver.id),
	      expression: "driver.id"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "hidden"
	    },
	    domProps: {
	      "value": _vm._s(_vm.driver.id)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.driver.id = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('span', {
	    staticClass: "input-group-addon"
	  }, [_vm._v("@")]), _vm._v(" "), _c('span', {
	    staticClass: "form-control"
	  }, [_vm._v(_vm._s(_vm.driver.name))])]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_vm._m(1), _vm._v(" "), _c('span', {
	    staticClass: "form-control"
	  }, [_vm._v(_vm._s(_vm.driver.email))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_vm._m(2), _vm._v(" "), _c('span', {
	    staticClass: "form-control"
	  }, [_vm._v(_vm._s(_vm.driver.license))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_vm._m(3), _vm._v(" "), _c('span', {
	    staticClass: "form-control"
	  }, [_vm._v(_vm._s(_vm.driver.phone))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_vm._m(4), _vm._v(" "), _c('span', {
	    staticClass: "form-control"
	  }, [_vm._v(_vm._s(_vm.driver.taxi))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-lg",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.deleteDriver
	    }
	  }, [_vm._v("Delete")])]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" ")]), _vm._v(" ")])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Personal Information")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('span', {
	    staticClass: "input-group-addon"
	  }, [_c('i', {
	    staticClass: "fa fa-envelope"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('span', {
	    staticClass: "input-group-addon"
	  }, [_c('i', {
	    staticClass: "fa fa-id-card-o"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('span', {
	    staticClass: "input-group-addon"
	  }, [_c('i', {
	    staticClass: "fa fa-tablet"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('span', {
	    staticClass: "input-group-addon"
	  }, [_c('i', {
	    staticClass: "fa fa-taxi"
	  })])
	}]}

/***/ },
/* 174 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row center-block"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }), _vm._v(" "), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
	    attrs: {
	      "id": "example1_wrapper"
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('table', {
	    staticClass: "table table-bordered table-striped dataTable",
	    attrs: {
	      "aria-describedby": "example1_info",
	      "role": "grid",
	      "id": "device-list"
	    }
	  }, [_vm._m(1), _vm._v(" "), _c('tbody'), _vm._v(" "), _c('tfoot', [_c('tr', [_c('th', {
	    attrs: {
	      "colspan": "1",
	      "rowspan": "1"
	    }
	  }, [_vm._v("#IID")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "colspan": "1",
	      "rowspan": "1"
	    }
	  }, [_vm._v("PS Service Version")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "colspan": "1",
	      "rowspan": "1"
	    }
	  }, [_vm._v("Manufacturer")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "colspan": "1",
	      "rowspan": "1"
	    }
	  }, [_vm._v("Model")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "colspan": "1",
	      "rowspan": "1"
	    }
	  }, [_vm._v("App Version")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "colspan": "1",
	      "rowspan": "1"
	    }
	  }, [_vm._v("Debug Version")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "colspan": "1",
	      "rowspan": "1"
	    }
	  }, [_vm._v("Facebook")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "colspan": "1",
	      "rowspan": "1"
	    }
	  }, [_vm._v("Messenger")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "colspan": "1",
	      "rowspan": "1"
	    }
	  }, [_vm._v("App Install Updated")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "colspan": "1",
	      "rowspan": "1"
	    }
	  }, [_vm._v("App Login Updated")])])])])])])]), _vm._v(" ")])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-6"
	  }, [_c('div', {
	    staticClass: "dataTables_length",
	    attrs: {
	      "id": "example1_length"
	    }
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('thead', [_c('tr', {
	    attrs: {
	      "role": "row"
	    }
	  }, [_c('th', [_vm._v("#IID")]), _vm._v(" "), _c('th', [_vm._v("Google Play Services")]), _vm._v(" "), _c('th', [_vm._v("Manufacturer")]), _vm._v(" "), _c('th', [_vm._v("Model")]), _vm._v(" "), _c('th', [_vm._v("App Version")]), _vm._v(" "), _c('th', [_vm._v("Debug Version")]), _vm._v(" "), _c('th', [_vm._v("Facebook")]), _vm._v(" "), _c('th', [_vm._v("Messenger")]), _vm._v(" "), _c('th', [_vm._v("App Install Updated")]), _vm._v(" "), _c('th', [_vm._v("App Login Updated")])])])
	}]}

/***/ },
/* 175 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row center-block"
	  }, [_c('div', {
	    staticClass: "panel panel-default"
	  }, [_c('div', {
	    staticClass: "panel-heading"
	  }, [_c('i', {
	    staticClass: "fa fa-clock-o fa-fw"
	  }), _vm._v(" Responsive Timeline\n            ")]), _vm._v(" "), _vm._v(" "), _c('div', {
	    staticClass: "panel-body"
	  }, [_c('ul', {
	    staticClass: "timeline"
	  }, [_c('li', [_c('div', {
	    staticClass: "timeline-badge"
	  }, [_c('i', {
	    staticClass: "fa fa-user-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "timeline-panel"
	  }, [_c('div', {
	    staticClass: "timeline-heading"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "timeline-body"
	  })])]), _vm._v(" "), _c('li', {
	    staticClass: "timeline-inverted"
	  }, [_c('div', {
	    staticClass: "timeline-badge warning"
	  }, [_c('i', {
	    staticClass: "fa fa-car",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "timeline-panel"
	  }, [_c('div', {
	    staticClass: "timeline-heading"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "timeline-body"
	  })])])])]), _vm._v(" ")])])])
	}]}

/***/ },
/* 176 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', [_c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box box-info"
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('ul', {
	    staticClass: "detail-list"
	  }, [_c('li', [_c('i', {
	    staticClass: "fa fa-id-card-o fa-cus-icon",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _c('span', {
	    staticClass: "label-list"
	  }, [_vm._v("ID")]), _c('span', {
	    staticClass: "result-list"
	  }, [_vm._v(_vm._s(_vm.device.id))])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "fa fa-key fa-cus-icon",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _c('span', {
	    staticClass: "label-list"
	  }, [_vm._v("IID")]), _c('span', {
	    staticClass: "result-list"
	  }, [_vm._v(_vm._s(_vm.device.iid))])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "fa fa-hourglass-half fa-cus-icon",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _c('span', {
	    staticClass: "label-list"
	  }, [_vm._v("App Install (Updated)")]), _c('span', {
	    staticClass: "result-list"
	  }, [_vm._v(_vm._s(_vm.device.updated))])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "fa fa-hourglass fa-cus-icon",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _c('span', {
	    staticClass: "label-list"
	  }, [_vm._v("App Login (Updated)")]), _c('span', {
	    staticClass: "result-list"
	  }, [_vm._v(_vm._s(_vm.device.loginupdate))])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "fa fa-cogs fa-cus-icon",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _c('span', {
	    staticClass: "label-list"
	  }, [_vm._v("Manufacturer")]), _c('span', {
	    staticClass: "result-list"
	  }, [_vm._v(_vm._s(_vm.device.manufacturer))])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "fa fa-barcode fa-cus-icon",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _c('span', {
	    staticClass: "label-list"
	  }, [_vm._v("Model")]), _c('span', {
	    staticClass: "result-list"
	  }, [_vm._v(_vm._s(_vm.device.model))])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "fa fa-exchange fa-cus-icon",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _c('span', {
	    staticClass: "label-list"
	  }, [_vm._v("App Version")]), _c('span', {
	    staticClass: "result-list"
	  }, [_vm._v(_vm._s(_vm.device.version))])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "fa fa-exchange fa-cus-icon",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _c('span', {
	    staticClass: "label-list"
	  }, [_vm._v("Debug Version")]), _c('span', {
	    staticClass: "result-list"
	  }, [_vm._v(_vm._s(_vm.device.vdevice))])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "fa fa-mobile-phone fa-cus-icon",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _c('span', {
	    staticClass: "label-list"
	  }, [_vm._v("Google Play Services")]), _c('span', {
	    staticClass: "result-list"
	  }, [_vm._v(_vm._s(_vm.device.gsmMajor) + _vm._s(_vm.device.gsmMinor))])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "fa fa-mobile-phone fa-cus-icon",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _c('span', {
	    staticClass: "label-list"
	  }, [_vm._v("gsmMajor")]), _c('span', {
	    staticClass: "result-list"
	  }, [_vm._v(_vm._s(_vm.device.gsmMajor))])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "fa fa-mobile-phone fa-cus-icon",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _c('span', {
	    staticClass: "label-list"
	  }, [_vm._v("gsmMinor")]), _c('span', {
	    staticClass: "result-list"
	  }, [_vm._v(_vm._s(_vm.device.gsmMinor))])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "fa fa-google fa-cus-icon",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _c('span', {
	    staticClass: "label-list"
	  }, [_vm._v("PlayStore Major")]), _c('span', {
	    staticClass: "result-list"
	  }, [_vm._v(_vm._s(_vm.device.playstoreMajor))])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "fa fa-google fa-cus-icon",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _c('span', {
	    staticClass: "label-list"
	  }, [_vm._v("PlayStore Minor")]), _c('span', {
	    staticClass: "result-list"
	  }, [_vm._v(_vm._s(_vm.device.playstoreMinor))])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "fa fa-location-arrow fa-cus-icon",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _c('span', {
	    staticClass: "label-list"
	  }, [_vm._v("gapiAviablity")]), _c('span', {
	    staticClass: "result-list"
	  }, [_vm._v(_vm._s(_vm.device.gapiAviablity))])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "fa fa-facebook-square fa-cus-icon",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _c('span', {
	    staticClass: "label-list"
	  }, [_vm._v("Facebook")]), _c('span', {
	    staticClass: "result-list"
	  }, [_vm._v(_vm._s(_vm.device.facebook))])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "fa fa-facebook-square fa-cus-icon",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _c('span', {
	    staticClass: "label-list"
	  }, [_vm._v("Messenger")]), _c('span', {
	    staticClass: "result-list"
	  }, [_vm._v(_vm._s(_vm.device.messenger))])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "fa fa-address-card fa-cus-icon",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _c('span', {
	    staticClass: "label-list"
	  }, [_vm._v("Name")]), _c('span', {
	    staticClass: "result-list"
	  }, [_vm._v(_vm._s(_vm.device.name))])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "fa fa-toggle-up fa-cus-icon",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _c('span', {
	    staticClass: "label-list"
	  }, [_vm._v("Major")]), _c('span', {
	    staticClass: "result-list"
	  }, [_vm._v(_vm._s(_vm.device.major))])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "fa fa-toggle-down fa-cus-icon",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _c('span', {
	    staticClass: "label-list"
	  }, [_vm._v("Minor")]), _c('span', {
	    staticClass: "result-list"
	  }, [_vm._v(_vm._s(_vm.device.minor))])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "fa fa-code-fork fa-cus-icon",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _c('span', {
	    staticClass: "label-list"
	  }, [_vm._v("Patch")]), _c('span', {
	    staticClass: "result-list"
	  }, [_vm._v(_vm._s(_vm.device.patch))])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "fa fa-id-card-o fa-cus-icon",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _c('span', {
	    staticClass: "label-list"
	  }, [_vm._v("SDK")]), _c('span', {
	    staticClass: "result-list"
	  }, [_vm._v(_vm._s(_vm.device.sdk))])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "fa fa-thermometer-2 fa-cus-icon",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _c('span', {
	    staticClass: "label-list"
	  }, [_vm._v("TotalMem")]), _c('span', {
	    staticClass: "result-list"
	  }, [_vm._v(_vm._s(_vm.device.totalMem))])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "fa fa-th-list fa-cus-icon",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _c('span', {
	    staticClass: "label-list"
	  }, [_vm._v("thresholdMem")]), _c('span', {
	    staticClass: "result-list"
	  }, [_vm._v(_vm._s(_vm.device.thresholdMem))])])])]), _vm._v(" ")])])])])])
	},staticRenderFns: []}

/***/ },
/* 177 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', [_c('router-view')])
	},staticRenderFns: []}

/***/ }
]);


// WEBPACK FOOTER //
// static/js/app.5351e50b520874960eaf.js